<template>
  <div class="total summary-data-container" v-loading="loadingStatus" element-loading-text="数据加载中……"
       element-loading-spinner="el-icon-loading">
    <module-header :title="`数据汇总(${condition.year}年${condition.month}月)`" desc="横坐标为下单时间">
      <div style="display: flex;align-items: center;">
        <el-switch v-model="switchCompareMonth" size="mini" @change="changeSwitch"/>
        <span :style="{cursor: 'pointer',color:switchCompareMonth?'#000':'#999'}"
              style="margin-left: 4px;">对比月</span>
      </div>
      <i slot="right" class="el-icon-refresh i-handel" style="font-size: 18px;" @click="getData"/>
    </module-header>
    <div class="t-b">
      <div class="t-b-l">
        <div v-if="switchCompareMonth">
          <el-table :data="tableTotalData" class="order-dashboard-table"
                    :header-row-style="{backgroundColor:'#fff'}">
            <el-table-column prop="month" label="月" width="65"/>
            <el-table-column prop="count" label="总订单数" width="80" align="right"/>
            <el-table-column prop="money" label="总订单金额" width="100" align="right"/>
          </el-table>
        </div>
        <div v-else class="grid">
          <div class="item" @click="toDetail">
            <div class="item_main">
              <div class="num active">{{ totalData.total_count }}</div>
              <div class="desc">
                <i class="el-icon-question"/>普通总数
              </div>
            </div>
          </div>
          <div class="item" @click="toDetail">
            <div class="item_main">
              <div class="num active">{{ gFunc.numberFormat(totalData.total_money) }}</div>
              <div class="desc">
                <i class="el-icon-question"/>普通总金额
              </div>
            </div>
          </div>
          <div class="item">
            <div class="item_main">
              <div class="num">{{ totalData.order_other_count }}</div>
              <div class="desc">
                <i class="el-icon-question"/>冲账总数
              </div>
            </div>
          </div>
          <div class="item">
            <div class="item_main">
              <div class="num">{{ gFunc.numberFormat(totalData.order_other_money) }}</div>
              <div class="desc">
                <i class="el-icon-question"/>冲账总金额
              </div>
            </div>
          </div>
          <div class="item">
            <div class="item_main">
              <div class="num">{{ totalData.total_count + totalData.order_other_count }}</div>
              <div class="desc">
                <i class="el-icon-question"/>合计总数
              </div>
            </div>
          </div>
          <div class="item">
            <div class="item_main">
              <div class="num">{{
                  gFunc.numberFormat((totalData.total_money / 1) + (totalData.order_other_money / 1))
                }}
              </div>
              <div class="desc">
                <i class="el-icon-question"/>合计总金额
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="totalChart"/>
    </div>
    <el-dialog title="对比月" class="compare-dialog" :visible.sync="dialogCompareMonth" width="500px"
               :before-close="dialogCompareMonthClose">
      <el-alert title="对比月功能只针对“数据汇总”板块进行多个月的数据对比，其他板块数据不会进行对比。" type="warning"
                :closable="false"/>
      <br/>
      <div v-for="(item,index) in compareMonths"
           :key="index + 'compareMonths'"
           style="margin-bottom: 16px;">
        <el-date-picker :clearable="false" v-model="compareMonths[index]" value-format="yyyy-MM" type="month"
                        placeholder="选择月"/>
        <template>
          <el-button @click="compareMonths.push('')" style="margin-left: 16px;" icon="el-icon-plus" circle
                     :style="{
                                pointerEvents: index + 1 === compareMonths.length ? 'all' : 'none',
                                opacity: index + 1 === compareMonths.length ? 1 : 0
                            }"
          >
          </el-button>
          <el-button v-if="compareMonths.length > 1"
                     @click="compareMonths.splice(index, 1)" style="margin-left: 16px;" type="danger" circle
                     icon="el-icon-delete"
          >
          </el-button>
        </template>
      </div>
      <el-button type="primary" @click="compareData" class="el-button--operation" style="margin-top: 20px;">
        点击对比数据
      </el-button>
    </el-dialog>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import {getDashboardSummary, getCompareMonthSummary} from "@/api/dashboard";
import ModuleHeader from "@/components/summary/ModuleHeader.vue";

let myChart

function resizeFun() {
  if (myChart)
    myChart.resize()
}

const option = {
  grid: {
    left: '5%',
    right: '2%',
    bottom: '8%',
  },
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      type: 'cross',
      crossStyle: {
        color: '#999'
      }
    }
  },
  legend: {
    left: '10%',
    itemWidth: 15,
    itemHeight: 10,
    data: ['订单量', '订单金额']
  },
  xAxis: {
    axisLine: {
      lineStyle: {
        color: '#B6B6B6',
      }
    },
    data: []
  },
  yAxis: [
    {
      type: 'value',
      name: '万元',
      min: 0,
      minInterval: 10000,
      axisLabel: {
        formatter: (value) => {
          return Number(value) / 10000
        },
        textStyle: {
          color: '#B6B6B6'
        }
      },
      splitLine: {
        // show: false,
        lineStyle: {
          type: 'dashed' //设置网格线类型 dotted：虚线 solid:实线
        },
      },
      axisLine: {
        lineStyle: {
          color: '#B6B6B6',
        }
      },
    },
    {
      type: 'value',
      name: '单',
      min: 0,
      interval: 50,
      axisLabel: {
        formatter: '{value}',
        textStyle: {
          color: '#B6B6B6'
        }
      },
      splitLine: {
        show: false,
      },
      axisLine: {
        lineStyle: {
          color: '#B6B6B6',
        }
      },
    }
  ],
  series: [
    {
      name: '订单量',
      type: 'line',
      yAxisIndex: 1,
      data: []
    },
    {
      barWidth: '20',
      name: '订单总额',
      type: 'bar',
      yAxisIndex: 0,
      data: []
    }
  ],
};

export default {
  name: "SummaryData",
  components: {ModuleHeader},
  inject: ['condition'],
  data() {
    return {
      dialogCompareMonth: false,
      switchCompareMonth: false,
      option: Object.assign({}, option),
      compareMonths: [''],
      tableTotalData: [],
      totalData: {total_count: 0, total_money: 0, order_other_count: 0, order_other_money: 0}, //数据汇总
      loadingStatus: false
    }
  },
  watch: {
    condition: {
      handler: function () {
        this.getData()
      },
      deep: true
    }
  },
  created() {
    window.addEventListener('resize', resizeFun)
    this.getData()
  },
  methods: {
    getData() {
      this.loadingStatus = true
      getDashboardSummary({
        year: this.condition.year,
        month: this.condition.month,
        organization_id: this.condition.organization_id
      }).then(res => {
        this.loadingStatus = false
        this.data = res.model;
        this.totalData.total_money = (res.model.total_money || 0) / 1;
        this.totalData.total_count = (res.model.total_count || 0) / 1;
        this.totalData.order_other_count = res.model.order_other_count / 1 || 0;
        this.totalData.order_other_money = res.model.order_other_money / 1 || 0;
        const xAxisData = res.model.x_data || [];
        const order_count = res.model.order_count;
        const order_money = res.model.order_money;
        myChart = echarts.init(document.getElementById('totalChart'));
        // this.switchCompareMonth = false; // 关闭对比月
        this.option.xAxis.data = xAxisData;
        this.option.legend.data = ['订单量', '订单金额'];
        this.option.series = [];
        const count = {
          name: '订单量',
          type: 'line',
          yAxisIndex: 1,
          data: order_count
        };
        const money = {
          name: '订单金额',
          type: 'bar',
          yAxisIndex: 0,
          barWidth: 10,
          itemStyle: {
            normal: {
              barBorderRadius: [9, 9, 0, 0]
            }
          },
          data: order_money
        };
        this.option.series.push(count);
        this.option.series.push(money);
        myChart.setOption(this.option, true)

        if (this.switchCompareMonth) {
          this.compareData()
        }
      })
    },
    changeSwitch() {
      this.dialogCompareMonth = this.switchCompareMonth;
      this.compareMonths = [this.condition.year + '-' + this.condition.month]; // 默认对比当前选中月份
      if (!this.switchCompareMonth) {
        this.getData()
      }
    },
    dialogCompareMonthClose() {
      this.switchCompareMonth = false
      this.dialogCompareMonth = false
    },
    compareData() {
      this.loadingStatus = true
      this.dialogCompareMonth = false
      let tableTotalData = []
      if (!Array.isArray(this.compareMonths)) {
        this.switchCompareMonth = false
        return;
      }
      this.compareMonths = this.compareMonths.filter(item => item)            // 过滤空字符串
      if (this.compareMonths.length < 1) {
        this.compareMonths.push('');
        this.switchCompareMonth = false
        return;
      }

      getCompareMonthSummary({times: this.compareMonths, organization_id: this.condition.organization_id}).then(res => {
        this.loadingStatus = false
        this.option.xAxis.data = res.model.x_data;
        const data = res.model.data;
        let legendData = []
        this.option.series = []
        for (let i = 0; i < data.length; i++) {
          const obj = data[i];
          const count = {
            name: obj.time + ' 订单量 ',
            type: 'line',
            yAxisIndex: 1,
            data: obj.order_count || []
          };
          const money = {
            barWidth: 10,
            name: obj.time + ' 订单金额',
            type: 'bar',
            yAxisIndex: 0,
            data: obj.order_money || []
          };
          legendData.push(obj.time + ' 订单量 ');
          legendData.push(obj.time + ' 订单金额');
          this.option.series.push(count);
          this.option.series.push(money);
          tableTotalData.push({month: obj.time, money: obj.total_money, count: obj.total_count})
        }
        this.option.legend.data = legendData
        myChart.setOption(this.option, true);
        this.tableTotalData = tableTotalData
      })
    },
    toDetail() {
      const {href} = this.$router.resolve({
        name: `dashboardOrderDetail`,
        query: {
          year: this.condition.year,
          month: this.condition.month || 0,
          organization_id: this.condition.organization_id
        }
      });
      window.open(href, "_blank");
    }
  }
}
</script>
<style lang="scss" scoped>
.total {
  height: 380px;
  background: #fff;
  padding: 20px;
  box-sizing: border-box;
}

.dashboard-table thead tr, .dashboard-table thead th {
  background-color: #fff !important;
}

.t-b {
  display: flex;
  justify-content: space-between;
  width: 100%;

  .t-b-l {
    width: 280px;
    margin-right: 20px;
  }
}

.grid {
  margin-top: 20px;
  display: grid;
  grid-template-columns: repeat(2, 140px);
  grid-template-rows: repeat(3, 70px);
  grid-gap: 20px;

  .item {
    border-radius: 6px;
    display: flex;
    box-shadow: 0 2px 10px 0 hsla(0, 0%, 92.2%, .5);
    align-items: center;
    justify-content: center;
    position: relative;
    cursor: pointer;

    .item_main {
      text-align: center;

      .num {
        font-size: 18px;
        font-weight: 700;

        &.active {
          color: #ff3176;
        }
      }

      .desc {
        color: #8a8e99;
      }
    }
  }
}

#totalChart {
  width: calc((100% - 300px));
  height: calc(380px - 48px - 50px);
}
</style>

<style lang="scss">
.summary-data-container {
  font-family: FjallaOne-Regular, sans-serif !important;

  .order-dashboard-table thead tr, .order-dashboard-table thead th {
    background-color: #fff !important;
    color: #313337 !important;
  }

  .compare-dialog {
    text-align: center;
  }
}
</style>
